import React from 'react';
import RenderSNA from '../components/sna/RenderSNA';

const SnaPage = () => (
	<div style={{ height: 'calc(100vh - 90px)', width: '100%' }}>
		<RenderSNA />
	</div>
);

export default SnaPage;
